<template>
    <button ref="signinBtn" class="loginBtn loginBtn--google">
      Login with Google
    </button>
</template>

<script>
    export default {
        name: 'GoogleButton',
        props: [
            'onLoggedIn', 'onFailed'
        ],
        mounted() {
            this.$loadScript('https://apis.google.com/js/api:client.js')
                .then(()=>{
                    window.gapi.load('auth2', () => {
                        const auth2 = window.gapi.auth2.init({
                            client_id: process.env.VUE_APP_GOOGLE_CLIENT_ID,
                            cookiepolicy: 'single_host_origin'
                        })
                        auth2.attachClickHandler(this.$refs.signinBtn, {}, googleUser => {
                            if (typeof this.onLoggedIn == 'function') {
                                this.onLoggedIn(googleUser)
                            }
                        }, () => {
                            if (typeof this.onFailed == 'function' ) {
                                this.onFailed();
                            }
                        })
                    })
                }).catch(() => {
                    if (typeof this.onFailed == 'function' ) {
                        this.onFailed();
                    }
                })
        }
    }
</script>

<style>
    /* Shared */
    .loginBtn {
        box-sizing: border-box;
        position: relative;
        padding: 0 15px 0 46px;
        border: none;
        text-align: left;
        line-height: 32px;
        white-space: nowrap;
        border-radius: 0.2em;
        font-size: 13px;
        color: #FFF;
    }
    .loginBtn:before {
        content: "";
        box-sizing: border-box;
        position: absolute;
        top: 0;
        left: 0;
        width: 34px;
        height: 100%;
    }
    .loginBtn:focus {
        outline: none;
    }
    .loginBtn:active {
        box-shadow: inset 0 0 0 32px rgba(0,0,0,0.1);
    }

    /* Google */
    .loginBtn--google {
        /*font-family: "Roboto", Roboto, arial, sans-serif;*/
        background: #DD4B39;
    }
    .loginBtn--google:before {
        border-right: #BB3F30 1px solid;
        background-image: url('https://s3-us-west-2.amazonaws.com/s.cdpn.io/14082/icon_google.png');
        background-position: 8px 9px;
        background-repeat: no-repeat;
        background-size: 17px 17px;
    }
    .loginBtn--google:hover,
    .loginBtn--google:focus {
        background: #E74B37;
    }
</style>
